<div class="container m-b-20 layout-row layout-lt-md-column align-end gap-2percent">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_DELINQUENCY_RANGE'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button
    mat-raised-button
    color="warn"
    (click)="deleteDelinquencyRange()"
    *LOSxHasPermission="'DELETE_DELINQUENCY_RANGE'"
  >
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Classification' | translate }}
        </div>

        <div class="flex-50">
          {{ delinquencyRangeData.classification }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Days From' | translate }}
        </div>

        <div class="flex-50">
          {{ delinquencyRangeData.minimumAgeDays }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Days Till' | translate }}
        </div>

        <div class="flex-50">
          {{ delinquencyRangeData.maximumAgeDays }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
